<div
    #originRef
    (click)="showPopover(originRef)"
    [class.bg-hover]="dropdownOpen"
    class="flex items-center rounded-full cursor-pointer relative transition duration-400 ease-out-swift select-none py-1 pr-1 pl-3 border border-outline hover:bg-hover"
    matRipple
>
    <div class="body-1 font-medium leading-snug ltr:mr-3 rtl:ml-3 hidden sm:block">
        {{ currentUser.firstName + ' ' + currentUser.lastName }}
    </div>
    <div
        class="rounded-full h-9 w-9 flex items-center justify-center overflow-hidden text-primary-600 bg-primary-600/10"
    >
        <img [src]="currentUser.profilePhotoLink" alt="Profile Photo" class="w-full" />
    </div>
</div>
